import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 48%;
  max-width: 700px;
  background-color: #fff;
  padding: 1.3rem 0.6rem 1.3rem 1.6rem;
`;

export const Title = styled.span`
  color: #212326;
  font-family: Sora;
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const TableContainer = styled.div`
  overflow-y: auto;
  border: 1px solid #c4c4c4;

  ::-webkit-scrollbar {
    width: 0.25rem;
  }
  ::-webkit-scrollbar-thumb {
    background: lightgray;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  td {
    vertical-align: middle;
    height: 4rem;
  }

  thead {
    th {
      position: sticky;
      z-index: 5;
      background-color: #fff;
      top: 0;
      color: #212326;
      font-size: 0.74rem;
      font-weight: 600;
    }
  }
  tbody {
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 0.25rem;
    }
    ::-webkit-scrollbar-thumb {
      background: lightgray;
    }
  }
`;

export const THColaborador = styled.th`
  padding-left: 1rem;
  text-align: start;
  width: 38%;
`;

export const THConcluidas = styled.th`
  width: 16.6%;
`;

export const THAtrasadas = styled.th`
  width: 15.2%;
`;

export const THPendentes = styled.th`
  width: 15.9%;
`;

export const THProdutividade = styled.th`
  width: 14.3%;
`;

export const TRLine = styled.tr`
  height: 4rem;
  align-items: center;
`;

export const TBColaborador = styled.td`
  display: flex;
  min-width: 38%;
  align-items: center;
`;

export const TBConcluidas = styled.td`
  min-width: 16.6%;
  text-align: center;

  color: #118052;
  font-family: Sora;
  font-size: 1rem;
  font-weight: 700;
`;

export const TBAtrasadas = styled.td`
  min-width: 15.2%;
  text-align: center;
  color: #d93333;
  font-size: 1rem;
  font-weight: 700;
`;

export const TBPendentes = styled.td`
  min-width: 15.9%;
  text-align: center;
  color: #7e858f;
  font-size: 1rem;
  font-weight: 700;
`;

export const TBProdutividade = styled.td`
  min-width: 14.3%;
  text-align: center;
`;
export const Avatar = styled.img`
  height: 2rem;
  width: 2rem;
  border-radius: 1rem;
  margin: 0rem 1rem;
`;
